<template>
  <section class="temple-intro">
    <h3 v-if="title">{{ title }}</h3>
    <p class="temple-intro__content">{{ intro }}</p>
    <div class="temple-intro__gods">
      <p>主祀：{{ gods[0] }}</p>
      <p>配祀：{{ gods[1] }}</p>
    </div>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'TempleIntro',
  props: {
    title: {
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    gods: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.temple-intro {
  text-align: justify;

  @include for-desktop {
    padding: 0;
  }

  > h3 {
    font-size: 1.125rem;
    line-height: 1.5;
    letter-spacing: 1px;
    padding-bottom: 0.5rem;
    margin: 0;
    color: $color-light-paragraph;
  }

  p {
    font-size: 1rem;
    line-height: 1.5;
    white-space: pre-line;
    text-align: justify;
    text-align-last: left;
    color: $color-light-paragraph;
  }

  &__content {
    margin-top: 0;
    margin-bottom: 20px;
  }

  &__gods {
    position: relative;
    padding: 10px 0;
    margin-bottom: 20px;
    > p {
      color: $color-light-text;
      font-weight: 600;
      margin: 0;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(
        to right,
        $color-white-light-border 1%,
        $color-light-border 20%,
        $color-light-border 76%,
        $color-white-light-border 99%
      );
    }

    &::before {
      top: 0;
    }

    &::after {
      bottom: 0;
    }
  }
}
</style>
